// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"65":"9b5a7054","88":"2c4221ad","142":"dbe68832","453":"d7446e4a","521":"71ad35b0","894":"9eff17a4","902":"43e5048b"}[chunkId] + ".chunk.js";
};